export const ERROR_OVER_PAYMENT = '交通費を含む合計報酬額が、{limit}円未満になるように設定してください。';
export const ERROR_OVER_DAY = '締め切り時間を過ぎている日が含まれています';
export const ERROR_NO_END_TIME = '終了時間を選択してください';
export const ERROR_OVER_WORK_TIME = '休憩時間を除く勤務時間が8時間以下（8時間はOK）になるように設定してください';
export const ERROR_CANNOT_SET_MYSHIFT = '「マイシフトを設定しない」に自動変更しました。<br>勤務時間が1時間未満のため、マイシフトを設定できません。';
export const ERROR_MINIMUM_WORK_DURATION = '勤務時間よりも15分以上短い時間で設定してください';
export const ERROR_REQUIRED_WORK_TIME_RANGE = '勤務時間よりも1分以上短い時間で設定してください';
export const ERROR_REQUIRED_MINIMUM_WORK_DURATION = '最低勤務時間(休憩時間を除く)を設定してください';
export const ERROR_NOT_SELECT_TARGET_USERS = '公開範囲を「指名公開」と選択した場合、ワーカーさんを1名以上選択してください。';
export const ERROR_JOB_CHANGE_POST_STOP_WORD_NOT_CONTRACTED = '選択された求人基本情報に、転職や採用を目的とした文言（例：転職者・面接・長期雇用など）が含まれているため、この求人は作成することができません。転職者向けの求人を掲載される場合は、「転職希望者限定求人機能」のご契約が必要です。';
export const ERROR_JOB_CHANGE_POST_STOP_WORD_NOT_SELECTED = '選択された求人基本情報に、転職や採用を目的とした文言（例：転職者・面接・長期雇用など）が含まれているため、この求人は作成することができません。これらの表現を含めて求人を掲載される場合は、求人基本情報一覧から「転職希望者限定」を選択してください。';
export const ERROR_JOB_CHANGE_POST_DATE_RANGE = '選択されている求人日が、「転職希望者限定求人機能」の契約期間を超えています。転職希望者限定求人として公開する場合は、契約期間内の日付に変更してください。';
export const errorJobChangePostDateRange = (period: string) =>
  `${ERROR_JOB_CHANGE_POST_DATE_RANGE}\n\n契約期間：${period}`;
export const ERROR_NOT_FAVORITE_TARGET_USERS = 'お気に入りに追加されているワーカーさんがいません。ワーカー管理画面またはワーカー詳細から、お気に入り追加を行ってください。';
export const ERROR_HIGH_HOURLY_PAY = '3,000円以上の時給を掲載したい場合は、お手数ですがカスタマーサポートまでご連絡ください。';
export const ERROR_REQUIRED_HOURLY_PAY = '時給を入力してください。';
export const ERROR_REQUIRED_EMAIL = 'メールアドレスを入力してください。';
export const ERROR_INVALID_EMAIL = 'メールアドレスの形式が正しくありません。';
export const ERROR_INVALID_EMAIL_DOMAIN = 'メールアドレスの形式が正しくありません。@以降を正しく入力してください。';
export const ERROR_MINIMUM_HOURLY_PAY = '最低賃金以上の時給を入力してください';
export const ERROR_REQUIRED_PUBLICATION_TYPE = '求人公開範囲を選択してください。';
export const ERROR_REQUIRED_START_TIME = '開始時間を選択してください。';
export const ERROR_REQUIRED_BREAK_START_TIME = '休憩開始時間を選択してください。';
export const ERROR_REQUIRED_MYSHIFT = 'マイシフトの設定を選択してください。';
export const ERROR_REQUIRED_WORK_TIME_RANGE_START = '必須勤務時間帯の開始時間を選択してください。';
export const ERROR_REQUIRED_WORK_TIME_RANGE_END = '必須勤務時間帯の終了時間を選択してください。';
export const ERROR_REQUIRED_TRANSPORTATION_EXPENSES = '交通費を選択してください。';
export const ERROR_REQUIRED_ENTRY_DEADLINE = '申込締切時間を選択してください。';
export const ERROR_REQUIRED_CANCEL_ACTION_TYPE = 'キャンセル発生時の対応を選択してください。';
export const errorAdditionalRecruitmentExtensionHours = (minWorkMinutes: number) =>
  `選択した開始延長時間では、追加募集の勤務時間が${minWorkMinutes}分未満になるため設定できません。勤務時間または開始延長時間を見直してください。`;
export const errorAdditionalRecruitmentWorkTimeTooShort = (minWorkMinutes: number) =>
  `勤務時間が最低時間（${minWorkMinutes}分）に満たないため、「追加募集をする」を設定できません。`;
export const errorCannotSetAdditionalRecruitment = (minWorkMinutes: number) =>
  `※当初の勤務時間が最低勤務時間（${minWorkMinutes}分）に満たないため、追加募集を設定することはできません。`;
export const errorSamedayPublishLimitSummary = (limit: number) =>
  `同じ求人日で公開できる上限（${limit}件）に達している求人日があります。`;
export const SAFETY_CHECK_VALIDATION_ERROR_MESSAGES = {
  reportType: '報告する項目を選択してください。',
  reportStatus: 'スポジョブ運営への報告について選択してください。',
  reportWorkIds: '問題があった勤務日を選択してください。',
  reportCategories: '問題のカテゴリを選択してください。',
  reportDetail: '問題の詳細を入力してください。',
  externalContactStatus: 'スポジョブ外での連絡について選択してください。',
  externalContactWorkIds: '該当する勤務日を選択してください。',
  externalContactCase: '該当する状況を選択してください。',
  images: '状況が確認できる画像を1枚以上登録してください。'
} as const;
export const ERROR_TERMS_AGREEMENT_FAILED = '利用規約の同意に失敗しました。再度お試しください。';
